import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { BehaviorSubject, first } from 'rxjs';

import { RegionsStoreService } from '@recruitee/country-data';
import type { CountryRegion } from '@recruitee/locations-types';
import { SelectOption } from '@recruitee/user-interface';

@Injectable()
export class DynamicFormLocationsService {
  public loadingRegions$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public regions$: BehaviorSubject<Array<SelectOption<string>>> = new BehaviorSubject(null!);

  constructor(
    private regionStoreService: RegionsStoreService,
    private store: Store,
  ) {}

  public getRegionsCollection(countryCode: string): void {
    this.loadingRegions$.next(true);
    this.regionStoreService
      .getOrLoadCountryRegions(countryCode)
      .pipe(first())
      .subscribe((regions: CountryRegion[]) => {
        const regionOptions = <Array<SelectOption<string>>>(
          regions.map((region: CountryRegion) => ({ label: region.name, value: region.code }))
        );
        this.regions$.next(regionOptions);
        this.loadingRegions$.next(false);
      });
  }
}
